import { render, staticRenderFns } from "./Weights.vue?vue&type=template&id=57b7f73a&"
import script from "./Weights.vue?vue&type=script&lang=js&"
export * from "./Weights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports